import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UIState } from '../../types'

const initialState: UIState = {
  sidebarOpen: true,
  notifications: [],
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload
    },
    addNotification: (state, action: PayloadAction<{
      type: 'success' | 'error' | 'warning' | 'info'
      message: string
    }>) => {
      const notification = {
        id: Date.now().toString(),
        ...action.payload,
        timestamp: new Date().toISOString(),
      }
      
      // Deduplicate: Check if a notification with the same message was added in the last 5 seconds
      const now = Date.now()
      const isDuplicate = state.notifications.some(n => {
        const nTime = new Date(n.timestamp).getTime()
        return n.message === notification.message && (now - nTime) < 5000
      })
      
      if (isDuplicate) {
        // Skip duplicate notification
        return
      }
      
      state.notifications.unshift(notification)
      
      // Keep only the last 10 notifications
      if (state.notifications.length > 10) {
        state.notifications = state.notifications.slice(0, 10)
      }
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      )
    },
    clearNotifications: (state) => {
      state.notifications = []
    },
  },
})

export const {
  setSidebarOpen,
  addNotification,
  removeNotification,
  clearNotifications,
} = uiSlice.actions

export default uiSlice.reducer
